import React from 'react'
import PropTypes from 'prop-types'

import BaseCardIcon from './CardIcon.base'

const Diners = ({ className }) => (
  <BaseCardIcon className={className} box='0 0 750 471'>
    <g fillRule='evenodd'>
      <path d="M0,40.0047706 C0,17.9107459 17.9143492,0 39.9919369,0 L710.008063,0 C732.095,0 750,17.9064659 750,40.0047706 L750,430.995229 C750,453.089254 732.085651,471 710.008063,471 L39.9919369,471 C17.905,471 0,453.093534 0,430.995229 L0,40.0047706 Z M584.933911,236.947339 C584.933911,137.53154 501.952976,68.8140806 411.038924,68.8471464 L332.79674,68.8471464 C240.793699,68.8140806 165.066089,137.552041 165.066089,236.947339 C165.066089,327.877778 240.793699,402.587432 332.79674,402.150963 L411.038924,402.150963 C501.952976,402.586771 584.933911,327.857939 584.933911,236.947339 Z M333.166996,82.6223815 C249.097073,82.6488342 180.972583,150.929824 180.952783,235.202123 C180.972583,319.459873 249.096413,387.73425 333.166996,387.760703 C417.256719,387.73425 485.395069,319.459873 485.406949,235.202123 C485.394409,150.929824 417.256719,82.6488342 333.166996,82.6223815 Z M236.682602,235.202123 C236.761801,194.021908 262.428934,158.90597 298.622956,144.951518 L298.622956,325.431566 C262.428934,311.48505 236.761141,276.388291 236.682602,235.202123 Z M367.697836,325.471245 L367.697836,144.945566 C403.905059,158.866291 429.611791,194.002068 429.67779,235.202123 C429.611791,276.414743 403.905059,311.524068 367.697836,325.471245 Z"></path>
    </g>
  </BaseCardIcon>
)

Diners.propTypes = {
  className: PropTypes.string
}

export default Diners



// WEBPACK FOOTER //
// ./src/core/icons/cards/Diners.base.js